var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBraSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 12,
    height: 12,
    rx: 6,
    fill: "#009F27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25873 8.03677L7.90389 5.10004L12.6104 7.98807L7.96522 10.9125L3.25873 8.03677Z",
    fill: "#FFDF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87676 8.40002C9.84574 8.55477 9.7956 8.70231 9.73067 8.84083C9.41033 9.52478 8.71628 9.99987 7.90932 9.99987C6.80043 9.99987 5.90076 9.10056 5.90076 7.99131C5.90076 7.79543 5.92889 7.60676 5.98192 7.4282C6.02485 7.27777 6.08545 7.13456 6.16012 7.00037C6.50751 6.39145 7.15972 5.98166 7.90932 5.98166C9.02002 5.98166 9.91897 6.88097 9.91897 7.99131C9.91897 8.13163 9.9049 8.26871 9.87676 8.40002Z",
    fill: "#00257B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.87499 8.46876L6.12499 7.06251L5.92341 7.58765L9.64966 9.02827L9.87499 8.46876Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBraSm);
export default __webpack_public_path__ + "static/media/BRA-SM.18e2a1607478993c5675b3ed22db12e7.svg";
export { ForwardRef as ReactComponent };